import React, { useEffect, useRef, memo } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Divider, List } from 'antd';
import CardProductos from '../../../components/ventas/CardProductos';
const IMAGE_FALLBACK = "https://placehold.co/500x500/e2e8f0/64748b?text=Sin+Imagen";

const SeccionVentasPrincipal = ({ procesarSeleccionProducto, productoCategoria, categoriaSeleccionada, setCarrito, setBusqueda }) => {

    const divScrollRef = useRef(null);

    useEffect(() => {
        if (divScrollRef.current) {
            divScrollRef.current.scrollTop = 0;
        }
    }, [categoriaSeleccionada]);

    return (
        <>
            {/** Lista de productos */}
            <div className='divListaProductos' ref={divScrollRef}>
                <InfiniteScroll
                    dataLength={productoCategoria.length}
                    hasMore={productoCategoria.length < 50}
                    endMessage={<Divider plain>No hay más productos de esta categoría.</Divider>}
                    scrollableTarget="scrollableDiv"
                >
                    <List
                        grid={{
                            gutter: 12,
                            xs: 2,
                            sm: 3,
                            md: 5,
                            lg: 6,
                            xl: 6,
                            xxl: 7,
                        }}
                        dataSource={productoCategoria}
                        style={{ marginTop: '0px' }}
                        renderItem={(item) => (
                            <List.Item style={{ marginBottom: '16px' }}>
                                <CardProductos 
                                    // Pasamos el objeto completo y la nueva función
                                    productoFull={item} 
                                    procesarSeleccionProducto={procesarSeleccionProducto}
                                    
                                    // Mantenemos estas por si tu CardProductos las usa para pintar el diseño
                                    id={item.id} 
                                    codigo_barras={item.codigo_barras} 
                                    nombre={item.nombre} 
                                    image={item.imagen_url || IMAGE_FALLBACK} 
                                    precioVenta={item.precio_venta} 
                                    stock={item.stock} 
                                    descuento={item.descuento} 
                                    setBusqueda={setBusqueda} 
                                />
                            </List.Item>
                        )}
                    />
                </InfiniteScroll>
            </div>
        </>
    )
}

export default memo(SeccionVentasPrincipal);